import { DrowpDown } from "../../../assets/images/svg/icon";
import DetectedSensitiveWordType from "./enum/type";
import "../style.scss";
import DetectedSensitiveWordState from "./enum/states";

type Props = {
  setSelect: Function;
};

const TypeOfActivity = ({ setSelect }: Props) => {
  const change = (e: any) => {
    if (e.target.value === "") {
      setSelect({
        statusCustomer: DetectedSensitiveWordState?.Block.toString(),
        typeActivity: e.target.value,
      });
    } else {
      setSelect({ typeActivity: e.target.value });
    }
  };
  return (
    <div className="d-flex justify-content-start align-items-center  ">
      <span>نوع فعالیت:</span>
      <div className="select-wrapper">
        <select
          className="form-control type-activity"
          onChange={(e) => change(e)}
        >
          <option value={DetectedSensitiveWordType?.IvrSetting.toString()}>
            کلمات حساس در سرویس گویا
          </option>
          <option value="">همه</option>
        </select>
        <span className="icon-selector">
          <DrowpDown />
        </span>
      </div>
    </div>
  );
};

export default TypeOfActivity;
